import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getOrganizationToConsolidationSetList } from '../../../store/Finance/ConsolidationSet/consolidationSetSlice';
// import { getBusinessGroupIdForPerson } from '../../../store/Login/loginSlice';
import { getBusinessGroupIdForPerson } from '../../../store/Login2/authSelectors';

const useGetConsolidationSet = () => {
  const dispatch = useAppDispatch();
  const businessGroupId = useAppSelector(getBusinessGroupIdForPerson);
  const { ConsolidationSetList, loading, error } = useAppSelector(
    (state) => state.ConsolidationSet
  );

  useEffect(() => {
    if (ConsolidationSetList?.length === 0) {
      dispatch(getOrganizationToConsolidationSetList());
    }
  }, []);

 
  // by businessGroupId from res loginSlice
  const GlCompanyId = ConsolidationSetList?.find(
    (f) => f.organizationId === businessGroupId && f.chartOfAccountsDetailsId !== null
  )?.chartOfAccountsDetailsId;

  //  fun Get Gl_branche_id
  const GetGlBrancheId = (HRBrancheId: string) => {
    let Gl_branche_id = ConsolidationSetList?.find(
      (f) => f.organizationId === HRBrancheId && f.chartOfAccountsDetailsId !== null
    )?.chartOfAccountsDetailsId;

    return Gl_branche_id;
  };

  //  fun Get Gl_ledgar_id
  const GetLedgarId = (HRBrancheId: string) => {
    let ledgar_id = ConsolidationSetList?.find(
      (f) =>
        f.organizationId === HRBrancheId &&
        f.chartOfAccountsDetailsId !== null &&
        f.ledgerId !== null
    )?.ledgerId;

    return ledgar_id;
  };

  return { ConsolidationSetList, GlCompanyId, GetGlBrancheId, GetLedgarId, loading, error };
};

export default useGetConsolidationSet;
